import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientMedicationControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveMedication = () =>
  useMutationWithLoading(
    async (param: {
      patientMedicationId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientMedicationControllerApi(
        getConfigObject()
      ).deletePatientMedicationId(
        param.patientMedicationId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );

  export const useArchiveMedicationMutation = () =>
    useMutationWithLoading(
      async (param: ArchiveMutation) =>
        new PatientMedicationControllerApi(
          getConfigObject()
        ).deletePatientMedicationId(
          param.id,
          param.status,
          param.xTENANTID //xTENANTID
        )
    );